// 案件调查
import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

// 案件调查分页
export function getSurveyPage(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/inquiryPage`,
        method: 'post',
        data
    })
}
// 案件详情
export function getSurveyDetail(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/detail`,
        method: 'post',
        data
    })
}
//笔录记录
export function getTranscriptRecordList(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseRecordOfWords/gl/v1.0.0/list`,
        method: 'post',
        data
    })
}
//新增笔录记录
export function addTranscriptRecord(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseRecordOfWords/gl/v1.0.0/addRecordOfWords`,
        method: 'post',
        data
    })
}
//录入调查信息
export function addSurveyInfo(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseSurvey/gl/v1.0.0/enteringCaseSurvey`,
        method: 'post',
        data
    })
}
//获取调查信息
export function getSurveyInfo(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseSurvey/gl/v1.0.0/getCaseSurvey`,
        method: 'post',
        data
    })
}
// 发送补材通知
export function sendSupplementaryNotice(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseMaterialSupplement/gl/v1.0.0/sendMaterialSupplement`,
        method: 'post',
        data
    })
}
// 获取补材通知
export function getSupplementaryNotice(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseMaterialSupplement/gl/v1.0.0/list`,
        method: 'post',
        data
    })
}

// 文书生成
export function generateDocument(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseWrit/gl/v1.0.0/generate`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}
//文书列表
export function getDocumentList(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseWrit/gl/v1.0.0/list`,
        method: 'post',
        data
    })
}
//文书预览文件流
export function previewDocument(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseWrit/gl/v1.0.0/examineGenerate`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}

// 案件导出
export function exportCase(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/inquiryExport`,
        method: 'post',
        data,
        responseType: 'blob'
    })
}
